const doc = [({"corrected":"Corrected invoice", "regular":"Regular invoice", "reversal":"Invoice reversal"})];
module.exports = doc.length <= 1 ? doc[0] : doc;